// import React, { useState } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';

// const Signup = () => {
//     const [formData, setFormData] = useState({
//         name: '',
//         email: '',
//         mobile: '',
//         password: '',
//         confirmPassword: '',
//     });

//     const [error, setError] = useState('');
//     const navigate = useNavigate();

//     // Handle Input Change
//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };

//     // Handle Signup Submission
//     const handleSignup = async (e) => {
//         e.preventDefault();

//         const { name, email, mobile, password, confirmPassword } = formData;

//         // Validation
//         if (!name || !email || !mobile || !password || !confirmPassword) {
//             setError('All fields are required');
//             return;
//         }

//         if (password !== confirmPassword) {
//             setError('Passwords do not match');
//             return;
//         }

//         try {
//             const response = await axios.post('https://qrapi.emedha.in/api/auth/signup', {
//                 name,
//                 email,
//                 mobile,
//                 password,
//             });

//             alert('Signup successful!');
//             navigate('/login');
//         } catch (err) {
//             console.error('Signup error:', err.response?.data?.error || err.message);
//             setError('Signup failed. Please try again.');
//         }
//     };

//     return (
//         <div style={styles.container}>
//             <h2>Signup</h2>
//             {error && <p style={styles.error}>{error}</p>}
//             <form onSubmit={handleSignup} style={styles.form}>
//                 <input
//                     type="text"
//                     name="name"
//                     placeholder="Full Name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     style={styles.input}
//                 />
//                 <input
//                     type="email"
//                     name="email"
//                     placeholder="Email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     style={styles.input}
//                 />
//                 <input
//                     type="text"
//                     name="mobile"
//                     placeholder="Mobile Number"
//                     value={formData.mobile}
//                     onChange={handleChange}
//                     style={styles.input}
//                 />
//                 <input
//                     type="password"
//                     name="password"
//                     placeholder="Password"
//                     value={formData.password}
//                     onChange={handleChange}
//                     style={styles.input}
//                 />
//                 <input
//                     type="password"
//                     name="confirmPassword"
//                     placeholder="Confirm Password"
//                     value={formData.confirmPassword}
//                     onChange={handleChange}
//                     style={styles.input}
//                 />
//                 <button type="submit" style={styles.button}>Signup</button>
//             </form>
//             <p>
//                 Already have an account? <a href="/login">Login</a>
//             </p>
//         </div>
//     );
// };


// // Inline CSS styles for simplicity
// const styles = {
//     container: {
//         maxWidth: '400px',
//         margin: '50px auto',
//         padding: '20px',
//         border: '1px solid #ccc',
//         borderRadius: '8px',
//         textAlign: 'center',
//         boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
   
//     },
//     error: {
//         color: 'red',
//         marginBottom: '10px',
//     },
//     form: {
//         display: 'flex',
//         flexDirection: 'column',
//         gap: '10px',
//     },
//     input: {
//         padding: '10px',
//         fontSize: '16px',
//         borderRadius: '4px',
//         border: '1px solid #ccc',
//     },
//     button: {
//         padding: '10px',
//         fontSize: '16px',
//         color: 'white',
//         background: '#007bff',
//         border: 'none',
//         borderRadius: '4px',
//         cursor: 'pointer',
//     },
// };

// export default Signup;




import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { useEffect } from 'react';

const Signup = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        mobile: '',
        password: '',
        confirmPassword: '',
    });

    const [error, setError] = useState('');
    const navigate = useNavigate();


        useEffect(() => {
        window.fbAsyncInit = function () {
            window.FB.init({
                appId: '1675564097169534', // Replace with your Facebook App ID
                cookie: true,
                xfbml: true,
                version: 'v18.0',
            });
        };

        (function (d, s, id) {
            let js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = 'https://connect.facebook.net/en_US/sdk.js';
            fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');
    }, []);

    // Handle Input Change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle Signup Submission
    const handleSignup = async (e) => {
        e.preventDefault();

        const { name, email, mobile, password, confirmPassword } = formData;

        // Validation
        if (!name || !email || !mobile || !password || !confirmPassword) {
            setError('All fields are required');
            return;
        }

        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        try {
            const response = await axios.post('https://qrapi.emedha.in/api/auth/signup', {
                name,
                email,
                mobile,
                password,
            });

            alert('Signup successful!');
            navigate('/login');
        } catch (err) {
            console.error('Signup error:', err.response?.data?.error || err.message);
            setError('Signup failed. Please try again.');
        }
    };

    // Handle Google login
    const handleGoogleLogin = async (response) => {
        try {
            const { credential } = response;
            const { email, name } = JSON.parse(atob(credential.split('.')[1])); 
            console.log(email)
            console.log(name)// Decode JWT token to get user info

            // Handle signup or login with email (you can adjust the logic as per your needs)
            const res = await axios.post('https://qrapi.emedha.in/api/auth/signup', {
                name,
                email,
                mobile: '123', // You can ask the user for a mobile number if needed
                password: '123', // You can generate a password or allow the user to set one
            });

            alert('Signup successful with Gmail!');
            const { user } = res.data;

            console.log(user)

            // Save user data in sessionStorage
            sessionStorage.setItem('userId', user.id);
            sessionStorage.setItem('userEmail', user.email);

            navigate('/dashboard'); // Redirect to Dashboard
        
        } catch (err) {
            console.error('Google Login error:', err.response?.data?.error || err.message);
            setError('Google signup failed. Please try again.');
        }
    };


const handleFacebookLogin = () => {
    if (!window.FB) {
        setError('Facebook SDK not loaded');
        return;
    }

    window.FB.getLoginStatus((response) => {
        if (response.status !== 'connected') {
            window.FB.login(
                (loginResponse) => {
                    if (loginResponse.authResponse) {
                        fetchFacebookUser();
                    } else {
                        setError('Facebook login failed');
                    }
                },
                { scope: 'public_profile,email' }
            );
        } else {
            fetchFacebookUser();
        }
    });
};

const fetchFacebookUser = () => {
    window.FB.api('/me', { fields: 'name,email' }, async (userInfo) => {
        const { name, email } = userInfo;

        try {
            const res = await axios.post('https://qrapi.emedha.in/api/auth/signup', {
                name,
                email,
                mobile: '123',
                password: '123',
            });

            alert('Signup successful with Facebook!');
            const { user } = res.data;

            sessionStorage.setItem('userId', user.id);
            sessionStorage.setItem('userEmail', user.email);

            navigate('/dashboard');
        } catch (err) {
            console.error('Facebook Signup error:', err.response?.data?.error || err.message);
            setError('Facebook signup failed. Please try again.');
        }
    });
};


    return (
        <div style={styles.container}>
            <h2>Signup</h2>
            {error && <p style={styles.error}>{error}</p>}
            <form onSubmit={handleSignup} style={styles.form}>
                <input
                    type="text"
                    name="name"
                    placeholder="Full Name"
                    value={formData.name}
                    onChange={handleChange}
                    style={styles.input}
                />
                <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                    style={styles.input}
                />
                <input
                    type="text"
                    name="mobile"
                    placeholder="Mobile Number"
                    value={formData.mobile}
                    onChange={handleChange}
                    style={styles.input}
                />
                <input
                    type="password"
                    name="password"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleChange}
                    style={styles.input}
                />
                <input
                    type="password"
                    name="confirmPassword"
                    placeholder="Confirm Password"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    style={styles.input}
                />
                <button type="submit" style={{...styles.button, marginTop:'20px'}}>Signup</button>
            </form>

            <div style={styles.googleSignInContainer}>
                <GoogleOAuthProvider clientId="953290113692-c8o4a6omfvki6g2j6it17bfkh634ebp7.apps.googleusercontent.com">
                    <GoogleLogin
                        onSuccess={handleGoogleLogin}
                        onError={(error) => setError('Google login failed. Please try again.')}
                    />
                </GoogleOAuthProvider>
                 <button
                    onClick={handleFacebookLogin}
                    style={{ ...styles.button, backgroundColor: '#3b5998' }}
                >
                    Signup with Facebook
                </button>
            </div>

            <p>
                Already have an account? <a href="/login">Login</a>
            </p>
        </div>
    );
};

// Inline CSS styles for simplicity
const styles = {
    container: {
        maxWidth: '450px',
        margin: '50px auto',
        padding: '20px',
        border: '1px solid #ccc',
        borderRadius: '8px',
        textAlign: 'center',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    },
    error: {
        color: 'red',
        marginBottom: '10px',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
    },
    input: {
        padding: '10px',
        fontSize: '16px',
        borderRadius: '4px',
        border: '1px solid #ccc',
    },
    button: {
        padding: '10px',
        fontSize: '16px',
        color: 'white',
        background: '#007bff',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
    },
    googleSignInContainer: {
        marginTop: '20px',
        display:'flex',
        alignItems:'center',
        justifyContent:'space-around',
        marginBottom: '20px',
    },
};

export default Signup;
